export enum LeaderboardParticipantType {
	All = 'all',
	Players = 'players',
	Bots = 'bots',
}
